export default "__VITE_ASSET__czqTTdiV__"